import React from 'react';
import { Tags } from '../Tags';
import {
  SearchBoxContainer,
  TagList,
  StyledTextLabel,
} from './styled.TaggedsView';
import { Body5 } from './../../typography';
import { useTranslation } from 'react-i18next';
import { ITaggedView } from './../../../@types/searchBox';

export function TaggedsView ({ selectedOptions }: ITaggedView) {
  const { t } = useTranslation();

  return (
    <SearchBoxContainer>
      <StyledTextLabel>
        <Body5 color="eerieBlack">{t('COMMON.MY_AUDIT.LABELS.TAGGED')}</Body5>
      </StyledTextLabel>
      <TagList>
        {selectedOptions.map((tag) => (
          <Tags key={tag.id} text={tag.text} disabled={true} />
        ))}
      </TagList>
    </SearchBoxContainer>
  );
}
